import React from 'react';
import { Card } from './Card';
import { twMerge } from 'tailwind-merge';

export const PlayerStatsCard = ({
  stats,
  isGoalie = false,
  variant = 'default',
  showSecondaryStats = true,
  className,
}) => {
  const points = !isGoalie ? (stats.goals || 0) + (stats.assists || 0) : null;
  const totalShots = isGoalie ? (stats.saves || 0) + (stats.goalsAgainst || 0) : null;
  const savePercentage =
    totalShots > 0 ? (((stats.saves || 0) / totalShots) * 100).toFixed(1) : '0.0';

  return (
    <Card variant={variant} className={twMerge('overflow-hidden', className)}>
      <div className="p-4">
        {/* Primary Stats */}
        <div className="flex justify-between items-center mb-4">
          <div>
            <div className="text-gray-400 text-sm">{stats.gamesPlayed || 0} Games Played</div>
            {!isGoalie ? (
              <div className="text-2xl font-bold text-white mt-1">{points} Points</div>
            ) : (
              <div className="text-2xl font-bold text-white mt-1">{savePercentage}% SV</div>
            )}
          </div>
          <div className="text-right">
            {!isGoalie ? (
              <>
                <div className="text-gray-400 text-sm">Goals / Assists</div>
                <div className="text-xl font-semibold text-white mt-1">
                  {stats.goals || 0} / {stats.assists || 0}
                </div>
              </>
            ) : (
              <>
                <div className="text-gray-400 text-sm">GAA</div>
                <div className="text-xl font-semibold text-white mt-1">
                  {stats.goalsAgainstAverage || '0.00'}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Main Stats Grid */}
        <div className="grid grid-cols-4 gap-4 text-center">
          {!isGoalie ? (
            <>
              <StatItem label="G" value={stats.goals || 0} />
              <StatItem label="A" value={stats.assists || 0} />
              <StatItem label="PTS" value={points} />
              <StatItem label="PIM" value={stats.penaltyMinutes || 0} />
            </>
          ) : (
            <>
              <StatItem label="SA" value={stats.shotsAgainst || 0} />
              <StatItem label="GA" value={stats.goalsAgainst || 0} />
              <StatItem label="SV" value={stats.saves || 0} />
              <StatItem label="MIN" value={stats.minutesPlayed || 0} />
            </>
          )}
        </div>

        {/* Secondary Stats */}
        {showSecondaryStats && !isGoalie && (
          <div className="grid grid-cols-3 gap-4 text-center mt-4 pt-4 border-t border-gray-700">
            <StatItem label="PPG" value={stats.powerPlayGoals || 0} size="small" />
            <StatItem label="SHG" value={stats.shortHandedGoals || 0} size="small" />
            <StatItem label="OTG" value={stats.overtimeGoals || 0} size="small" />
          </div>
        )}
      </div>
    </Card>
  );
};

const StatItem = ({ label, value, size = 'default' }) => (
  <div>
    <div className={twMerge('text-white font-medium', size === 'small' ? 'text-sm' : 'text-lg')}>
      {value}
    </div>
    <div className={twMerge('text-gray-400', size === 'small' ? 'text-xs' : 'text-sm')}>
      {label}
    </div>
  </div>
);
